import { useRouter } from '@/hooks';

export const useErrorPage = (statusCode: number | undefined) => {
  const router = useRouter();

  if (statusCode === 200) {
    return undefined;
  }

  const redirectToErrorPage = () => {
    router.replace({
      pathname: '/error',
      query: {
        statusCode: `${statusCode}`,
      },
    });
  };

  return redirectToErrorPage;
};
